import 'Styles/infinitescroller.scss';

import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import PageSelector from 'Components/infiniteScroll/PageSelectorComponent';
import LoaderCss from 'Components/common/LoaderCssComponent';

import infiniteScrollSelector from 'Selectors/infiniteScrollSelector';
import { updatePageNumber, FRAME_SIZE } from 'Actions/InfiniteScrollActions';

import throttle from 'lodash/throttle';
import isEqual from 'lodash/isEqual';

class InfiniteScrollComponent extends React.Component {
	constructor( props ) {
		super( props );

		this.state = {
			bottomPosition: 0
		};

		this.suppressScrollListener = true;
		this.justRepositioned = false;
		this.currentPos = 0;
		this.previousPos = 0;

		this.isLoadingTop = false;
		this.isLoadingBottom = false;
		this.previousState = {
			page: 0,
			offset: 0
		};
		this.scrollTopBeforeUpdate = 0;
		this.breadCrumbHeight = 0;
		this.headerHeight = 0;
		this.bottomFloatingAd = null;
		this.rePositionFixAdTimer = null;
	}

	componentWillMount() {
		// Getting header height, for the breadcrumb we need to wait until is mounted
		let header = document.getElementById( 'header' );
		this.headerHeight = header.getBoundingClientRect().height;
	}

	componentDidMount() {
		// To be sure we have the correct page number
		this.updatePageNumber( this.props.page );

		// Getting breadcrumb height
		let breadCrumb = document.getElementById( 'breadCrumbBar' );
		this.breadCrumbHeight = ( breadCrumb ? breadCrumb.getBoundingClientRect().height : 0 );

		// Getting bottom floating height
		this.bottomFloatingAd = document.getElementById( 'Fixed_Bottom_Leaderboard_container' );
		this.rePositionFixAdTimer = setTimeout( () => {
			this._getBottomFixAdPosition()
		}, 1000 );

		this.attachScrollListener();
	}

	componentWillUnmount() {
		this.detachScrollListener();

		if( this.rePositionFixAdTimer ) {
			clearTimeout( this.rePositionFixAdTimer );
			this.rePositionFixAdTimer = undefined;
		}
	}

	componentWillReceiveProps( nextProps ) {
		if( nextProps.iOSkeyBoardOpen !== this.props.iOSkeyBoardOpen ) {
			this.setState( {
				bottomPosition: 0
			} );
		}
	}

	shouldComponentUpdate( nextProps, nextState ) {
		return (
			nextProps.totalPages !== this.props.totalPages ||
			nextProps.page !== this.props.page ||
			nextProps.isFetching !== this.props.isFetching ||
			!isEqual( nextProps.pages, this.props.pages ) ||
			nextState.bottomPosition !== this.state.bottomPosition ||
			nextProps.adSlots.Fixed_Bottom_Leaderboard !== this.props.adSlots.Fixed_Bottom_Leaderboard ||
			nextProps.extraHeaderHeight !== this.props.extraHeaderHeight
		);
	}

	componentWillUpdate( nextProps ) {
		this.suppressScrollListener = true;
		// Let's get the current scroll position
		this.scrollTopBeforeUpdate = window.scrollY;
		this.previousState.page = nextProps.pages[ 0 ];
		this.previousState.offset = this._getPageDimensions( nextProps.page ).offsetTop;
	}

	componentDidUpdate( prevProps, prevState ) {
		// If the fixed bottom ad changed then reposition the page selector
		try {
			if(
				prevProps.adSlots.Fixed_Bottom_Leaderboard !== this.props.adSlots.Fixed_Bottom_Leaderboard ||
				prevState.bottomPosition !== this.state.bottomPosition
			) {
				if( this.rePositionFixAdTimer ) {
					clearTimeout( this.rePositionFixAdTimer );
					this.rePositionFixAdTimer = undefined;
				}
				this._getBottomFixAdPosition();

				this.rePositionFixAdTimer = setTimeout( () => {
					this._getBottomFixAdPosition()
				}, 500 );
			}
		} catch( e ) { /* ignore it */ }

		// Do we need to fix Scroll Position?
		if(
			this.listRef &&
			this.props.pages[ 0 ] !== this.props.page &&
			(
				(
					this.props.isFetching === false &&
					this.previousState.page === this.props.pages[ 0 ]
				) || // when going up: not fetching and new page (lastPage) will be on pos 0
				prevProps.pages[ 1 ] === this.props.pages[ 0 ] // when going down: first page removed and previous pos 1 is now 0
			)
		) {

			this._fixScrollPosition();
		}

		// Reset if needed isLoadingTop and isLoadingBottom
		if( prevProps.isFetching !== this.props.isFetching && !this.props.isFetching ) {
			this.isLoadingTop = this.isLoadingTop && this.props.isFetching;
			this.isLoadingBottom = this.isLoadingBottom && this.props.isFetching;
		}

		this.suppressScrollListener = false;

		// If page changed or if we just landed on the section,
		// we need to check if we need to load next page
		// even before the user scrolls
		if(
			this._overflowItemsOpen() === false &&
			this.props.totalPages > 0 && // If we have pages at all
			(
				prevProps.page !== this.props.page || // page changed
				( this.props.pages.length === 1 && this.props.totalPages !== this.props.page ) // we only have 1 page loaded and there are more
			)
		) {
			this._needLoadNewPage();
		}
	}

	_overflowItemsOpen = () => {
		return (
			this.props.iOSkeyBoardOpen ||
			this.props.announcementsOpen ||
			this.props.shareModalOpened ||
			this.props.headerOverflowOpened ||
			this.props.sidebarOpened ||
			this.props.userModalOpened ||
			this.props.searchBarOpened
		);
	};

	_fixScrollPosition() {
		this.suppressScrollListener = true;

		// diff between distances from current page to the top and
		// previous current page before to the top is the diff in the scroll
		let pageDims = this._getPageDimensions( this.props.page ),
			diffFromTop = pageDims.offsetTop - this.previousState.offset;

		if( diffFromTop ) {
			window.scrollTo( 0, this.scrollTopBeforeUpdate + diffFromTop );
			this.justRepositioned = true;
		}

		this.previousPos = window.scrollY;
		this.suppressScrollListener = false;
	}

	attachScrollListener() {
		this.suppressScrollListener = false;
		window.addEventListener( "resize", this.synchronizePages );
		window.addEventListener( "scroll", this.throttleScroll );
	}

	detachScrollListener() {
		this.suppressScrollListener = true;
		this.throttleScroll.cancel();
		window.removeEventListener( "resize", this.synchronizePages );
		window.removeEventListener( "scroll", this.throttleScroll );
	}

	loadPage = ( page, forceRefresh = false ) => {
		page = parseInt( page );
		if( page === this.props.page ) {
			return null;
		}

		// Stop listening for scroll
		this.suppressScrollListener = true;

		// If the page we want is already in screen, just scroll to it
		let gotoPageDim = this._getPageDimensions( page );
		if( gotoPageDim.height ) {
			// If we have breadCrumb bar we want to scroll bellow it
			let topPageHeight = this.props.extraHeaderHeight + this.headerHeight + this.breadCrumbHeight,
				scroll_y = window.scrollY + gotoPageDim.top - topPageHeight;

			// Scroll to the top of the page we want to go to
			window.scrollTo( 0, scroll_y );

			// Update the page number
			this.updatePageNumber( page );

			// Done
			return true;
		}

		if( page < this.props.page - FRAME_SIZE + 1 || page > this.props.page + FRAME_SIZE - 1 ) {
			if( page < this.props.page - FRAME_SIZE || page > this.props.page + FRAME_SIZE ) {
				forceRefresh = true;
				window.scrollTo( 0, 0 );
			}

			new Promise( ( resolve ) => {
				resolve( this.props.loadPage( page, forceRefresh ) );

			} ).then( () => {
				this.isLoadingTop = false;
				this.isLoadingBottom = false;
				this.suppressScrollListener = false;
			} );

		} else {
			window.scrollTo( 0, window.scrollY + this._getPageDimensions( page ).top );
			this.updatePageNumber( page );
		}
	};

	loadPreviousPage = () => {
		const { page } = this.props;
		this.isLoadingTop = true;
		this.loadPage( page - 1 );
	};

	loadNextPage() {
		const { page } = this.props;
		this.isLoadingBottom = true;
		this.loadPage( page + 1 )
	}

	synchronizePages = () => {
		const scrollDirection = this.scrollDirection; // calling it once
		// Skip sync if we have a replyModal or confirmModal open
		let skipUpdate = history.state && ( history.state.type === 'confirmModal' || history.state.type === 'replyModal' );

		if( this._isLoading() || skipUpdate || scrollDirection === undefined ) {
			return null;

		} else {
			let pageRect,
				theSelectedPage = null,
				topPageHeight = this.props.extraHeaderHeight + this.headerHeight - this.breadCrumbHeight;

			// Go through all current pages to check where we are
			this.props.pages.forEach( ( p ) => {
				// if we are 'up' we take the first one matching
				// otherwise we'll take the latest
				if( scrollDirection === 'up' && theSelectedPage ) {
					return; // skip to next one because forEach will run through all
				}
				pageRect = this._getPageDimensions( p );

				if(
					( pageRect.top > 0 && pageRect.top < window.innerHeight - this.state.bottomPosition ) || 		// just show up from the bottom
					( pageRect.bottom < window.innerHeight && pageRect.bottom > topPageHeight ) || 		// just show up from the top
					( pageRect.top < window.innerHeight - this.state.bottomPosition && pageRect.bottom >= window.innerHeight - this.state.bottomPosition ) 	// it's totally on viewport
				) {
					theSelectedPage = p;
				}
			} );

			this.updatePageNumber( ( theSelectedPage || this.props.page ) );
		}
	};

	get scrollDirection() {
		if( this.previousPos ) {
			switch( true ) {
				case (this.currentPos > this.previousPos):
					this.prevDirection = 'down';
					break;

				case (this.currentPos < this.previousPos):
					this.prevDirection = 'up';
					break;
			}
		}

		this.previousPos = this.currentPos;
		return this.prevDirection;
	}

	// Throttle the scroll listener to every 100ms
	throttleScroll = throttle( () => {
		const { page }  = this.props,
			diffPos = ( this.previousPos - this.currentPos );

		// Skip the first catch after forcing reposition
		if( this.justRepositioned ) {
			this.justRepositioned = false;
			return true;
		}

		// save position
		this.currentPos = window.scrollY;

		// do we force skip?
		if( this.suppressScrollListener || this._overflowItemsOpen() ) {
			return false;
		}

		// if the page is loading skip
		if( this._isLoading() ) {
			return false;
		}

		let currentPage = this._getPageDimensions( page ),
			diffOffset = this.previousState.offset - currentPage.offsetTop;

		// Skip because previous page have changed in size,
		// probably ads or images loading or ads clearing
		if( diffOffset === diffPos ) {
			return false;
		}

		// Do we need to load a new page or sync pages?
		if( this._needLoadNewPage() === false ) {
			this.synchronizePages();
		}

	}, 100, {
		'leading': true,
		'trailing': true
	} );

	updatePageNumber( page ) {
		const { location } = this.props;

		// Do we need to update? avoid updating if everything is already OK
		let currentQueryPage = this.props.location.query && this.props.location.query.page ? parseInt( this.props.location.query.page ) : null;

		if(
			isFinite( page ) === false || // page passed is not a number
			( page === 1 && currentQueryPage === null ) || // we are in page 1 and we have the query saying otherwise
			currentQueryPage === page // the querystring already says we are here
		) {
			this.previousPos = window.scrollY;
			this.suppressScrollListener = false;
			return true;
		}

		this.suppressScrollListener = true;

		new Promise( ( resolve ) => {
			resolve( this.props.dispatch( updatePageNumber( location, page, location.pathname ) ) );
		} ).then( () => {
			this.suppressScrollListener = false;
		} );
	}

	loadingAnimation = ( pos ) => {
		return <LoaderCss container={ false } className={ pos }/>;
	};

	loadPreviousButton() {
		return <div className="loadMore" onClick={this.loadPreviousPage}>Load Previous</div>;
	}

	topLoader() {
		const { page, pages } = this.props;

		if( this.isLoadingTop ) {
			return this.loadingAnimation( 'top' );

		} else if( pages[ 0 ] > 1 && ( pages.length <= 1 || page === pages[ 0 ] ) ) {
			return this.loadPreviousButton();
		}
	}

	bottomLoader() {
		const { totalPages, page } = this.props;

		if( page <= totalPages && this.isLoadingBottom ) {
			return this.loadingAnimation( 'bottom' );
		}
	}

	/**
	 * Get all dimensions we wanna use about one page
	 * getBoundingClientRect ( height, top, bottom... ) and offsetTop
	 *
	 * @param page
	 * @returns {*}
	 * @private
	 */
	_getPageDimensions( page ) {
		let defaultDimensions = { height: 0, top: 0, bottom: 0, width: 0, offsetTop: 0 };

		try {
			let thePage = this.listRef.getElementsByClassName( `page_${ page }` )[ 0 ];
			return Object.assign( thePage.getBoundingClientRect(), { offsetTop: thePage.offsetTop } );
		} catch( e ) {
			return defaultDimensions;
		}
	}

	_isLoading() {
		return this.props.isFetching || this.isLoadingTop || this.isLoadingBottom;
	}

	_needLoadNewPage() {
		// we check first natural order ( bottom - next page ) then
		// check the other way ( top - previous page )
		if(
			!this._isLoading() && // if loading, skip
			this.props.totalPages > this.props.page && // if we are at the bottom, skip
			this.props.pages.indexOf( this.props.page + 1 ) < 0 // if we have the page already loaded, no need
		) {
			// Load Next page
			this.loadNextPage();
			return true;

		} else if(
			!this._isLoading() && // if loading, skip
			this.props.page !== 1 && // if we are at top, skip
			this.props.pages.indexOf( this.props.page - 1 ) < 0 // if we already have the previous page, no need
		) {
			// Load Previous page
			this.loadPreviousPage();
			return true;
		}

		return false;
	}

	_getBottomFixAdPosition() {
		let bottomFloatingAd = this.bottomFloatingAd || document.getElementById( 'Fixed_Bottom_Leaderboard_container' );
		if( bottomFloatingAd ) {
			try {
				this.setState( {
					bottomPosition: bottomFloatingAd.getBoundingClientRect().height
				} );
			} catch( e ) { /* ignore */
			}
		}
	}

	render() {
		const { page, totalPages } = this.props;

		const childrenWithProps = React.Children.map( this.props.children, ( child ) => {
			if( child ) {
				return React.cloneElement( child, {
					pages: this.props.pages,
					listRef: list => this.listRef = list
				} );
			}
		} );

		let style = { paddingTop: Math.round( this.props.extraHeaderHeight ) + 1 + 'px' };

		return (
			<div id='scroll' ref={ this.props.scrollRef } style={ style }>
				{ this.topLoader() }
				{ childrenWithProps }
				{ this.bottomLoader() }
				<PageSelector
					currentPage={ page }
					totalPages={ totalPages }
					onFirstButtonClick={ () => this.loadPage( 1 ) }
					onLastButtonClick={ () => this.loadPage( totalPages ) }
					onJumpPage={ ( newPage ) => this.loadPage( newPage, true ) }
					bottomPosition={ this.state.bottomPosition }
				/>
			</div>
		);
	}
}

InfiniteScrollComponent.defaultProps = {
	page: 1,
	totalPages: 0,
	extraHeaderHeight: 0,
	earliestLoadedPage: null,
	latestLoadedPage: null
};

InfiniteScrollComponent.propTypes = {
	page: PropTypes.oneOfType( [
		PropTypes.string,
		PropTypes.number
	] ),
	totalPages: PropTypes.number.isRequired,
	isFetching: PropTypes.bool.isRequired,
	loadPage: PropTypes.func.isRequired,
	location: PropTypes.object.isRequired,
	earliestLoadedPage: PropTypes.number,
	latestLoadedPage: PropTypes.number,
	scrollRef: PropTypes.func.isRequired
};

export default connect( infiniteScrollSelector )( InfiniteScrollComponent );



// WEBPACK FOOTER //
// ./src/components/infiniteScroll/InfiniteScrollComponent.js